// src/components/restake/index.tsx

import React, { useState } from "react";
import { Typography, Card, Tab } from "@kelp-dao/kernel-design-system";
// import RestakeForm from "./RestakeForm";
import AssetsRestaked from "./AssetsRestaked";
import GainOpportunities from "./GainOpportunities";
import { ETabs, TRestakeUnstakeProps } from "./types";
import Withdraw from "./Withdraw";
import HeaderStats from "./HeaderStats";
import useExchangeRate from "@hooks/useExchangeRate";
import StakeComponent from "./StakeComponent";
import UnstakeComponent from "../Unstake";
import useDappChain from "@hooks/useDappChain";
import { trackEvent } from "utils";

// Define tabs data
const TABS = [
  { label: "Restake", value: ETabs.RESTAKE },
  { label: "Unstake", value: ETabs.UNSTAKE },
  { label: "Withdraw", value: ETabs.WITHDRAW },
];

const RestakeUnstake: React.FC<TRestakeUnstakeProps> = ({
  initialTab = "restake",
  title = "Restake ETH & LSTs",
  showAssetsRestaked = true,
  showGainOpportunities = true,
}) => {
  const [activeTab, setActiveTab] = useState<string>(initialTab);
  const { isEthereumChain } = useDappChain();
  const conversionData = useExchangeRate();

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    trackEvent("RESTAKE_TAB_CHANGE", {
      restake_tab: tab,
    });
  };

  const renderTabs = () => {
    switch (activeTab) {
      case ETabs.WITHDRAW:
        return <Withdraw />;
      case ETabs.RESTAKE:
        return (
          <StakeComponent conversionData={conversionData} isActive={true} />
        );
      case ETabs.UNSTAKE:
        return (
          <UnstakeComponent conversionData={conversionData} isActive={true} />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="w-full max-w-full md:max-w-[548px]">
        <div className="w-full mx-auto">
          {/* Header section with title and stats */}
          <div className="flex items-end justify-between mb-8">
            <div>
              <Typography
                type="heading"
                variant="xsmall"
                className="text-text-primary text-[20px] lg:text-[24px] lg:font-semibold font-sans font-medium"
              >
                {title}
              </Typography>
            </div>

            <HeaderStats />
          </div>

          {/* Main restaking card */}
          <div className="relative">
            <Card
              variant="non-bordered"
              className="w-full md:w-[548px] mx-auto bg-bg-card shadow-sm rounded-2xl overflow-hidden relative z-[2] p-4 sm:px-8 sm:py-8"
            >
              <div>
                {/* Tabs */}
                <div className="mb-8 custom-tab-container">
                  <Tab
                    tabs={TABS}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                    tabClassName="text-[12px] md:text-[14px]"
                  />
                </div>

                {renderTabs()}
              </div>
            </Card>

            {/* Assets Restaked */}
            {showAssetsRestaked && isEthereumChain && <AssetsRestaked />}
          </div>

          {/* Gain Opportunities */}
          {showGainOpportunities && <GainOpportunities />}
        </div>
      </div>
    </>
  );
};

export default RestakeUnstake;
